import React from 'react';

/** Lays out a label + control + hint/error consistently, for controls that aren't themselves Input/Select. */
export function FormField({ label, required, hint, error, children }) {
  return (
    <div style={{ display: 'grid', gap: '6px' }}>
      {label && (
        <div style={{ fontSize: 'var(--fs-body-sm)', fontWeight: 500, color: 'var(--text-1)' }}>
          {label}{required && <span style={{ color: 'var(--status-danger-text)' }}> *</span>}
        </div>
      )}
      {children}
      {(hint || error) && (
        <span style={{ fontSize: 'var(--fs-caption)', color: error ? 'var(--status-danger-text)' : 'var(--text-muted)' }}>{error || hint}</span>
      )}
    </div>
  );
}
